var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticStyle:{"margin-bottom":"50px"},attrs:{"fluid":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }